import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import { Seo } from '@/components/generals/seo'
import { AuthLayout } from '@/components/auth/auth-layout'
import { SignupForm } from '@/components/auth/auth-forms'
import { getSessionAccount } from '@/lib/auth'

const Signup: FC = (): ReactNode => {
    return (
        <>
            <Seo title='Sign up' description='Create your Veyra account and start a 14-day free trial. No credit card required.' />

            <AuthLayout
                title='Create your workspace.'
                description='Start a 14-day free trial. No credit card required, and you can explore everything with sample data before connecting a single account.'
            >
                <SignupForm />
            </AuthLayout>
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
    try {
        const account = await getSessionAccount(req)

        if (account) return { redirect: { destination: '/app', permanent: false } }
    }
    catch (error) {
        console.error('Could not check the session:', error instanceof Error ? error.message : error)
    }

    return { props: {} }
}

export default Signup
